import { type ExportFileField } from './ExportFileTypes.ts';

export function mapSelectedFieldsToFileFields(
  selectedKeys: string[],
  fields: ExportFileField[] | undefined,
) {
  // I campi devono essere elencati come lista di oggetti e non come lista di chiavi.
  // Gli oggetti sono gli stessi ritornati dall'API dedicata.
  const selected = selectedKeys
    .map(selectedKey => fields?.find(({ id }) => id === selectedKey))
    .filter(Boolean);

  // L'API accetta come input un oggetto json stringificato
  return JSON.stringify(selected);
}
